import React from 'react'
import ContactUsSection from '../components/contactus/ContactUsSection'
import SendMessage from '../components/home/SendMessage'
import NeedOfCustomDesign from '../components/home/NeedOfCustomDesign'
import FollowOnInstagram from '../components/home/FollowOnInstagram'
import OurContactInfo from '../components/contactus/OurContactInfo'

const ContactUs = () => {
  return (
    <>
      <ContactUsSection />
      <OurContactInfo />
      <SendMessage />
      <NeedOfCustomDesign />
      <FollowOnInstagram />
    </>
  )
}

export default ContactUs